'use client';
import { FC } from 'react';

import type { EntryFields } from 'contentful';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { LeadFormType } from '../../../../models/Content';
import { AddressField } from '../../fields/AddressField';
import { CommentField } from '../../fields/CommentField';
import { CompanyCodeNameField } from '../../fields/CompanyCodeNameField';
import { EmailAddressField } from '../../fields/EmailAddressField';
import { NameSurnameField } from '../../fields/NameSurnameField';
import { PhoneField } from '../../fields/PhoneField';
import { ProductTypeField } from '../../fields/ProductTypeField';
import { Description, LeadContent } from './LeadFormContent.styles';

type Fields = LeadFormType['fields']['fields'];
type Field = Fields[number];

type Props = {
    description: EntryFields.RichText;
    legalText: EntryFields.RichText;
    commentHint?: string;
    productTypeValue?: string;
    fields: Fields;
};

export const LeadFormContent: FC<Props> = ({ description, commentHint, legalText, productTypeValue, fields }) => {
    const has = (field: Field) => fields.includes(field);

    return (
        <LeadContent>
            {description && <Description richText={description} />}
            {has('NAME_SURNAME') && <NameSurnameField />}
            {has('COMPANY_CODE_NAME') && <CompanyCodeNameField />}
            {has('PHONE_NUMBER') && <PhoneField isPrefilled={true} />}
            {has('PHONE_NUMBER_NO_PREFILL') && <PhoneField />}
            {has('EMAIL_ADDRESS') && <EmailAddressField />}
            {has('ADDRESS') && <AddressField />}
            {has('PRODUCT_TYPE') && <ProductTypeField value={productTypeValue} />}
            {has('COMMENT') && <CommentField helpText={commentHint} />}
            {legalText && <RichTextContent richText={legalText} />}
        </LeadContent>
    );
};
